import { Slider } from '@mui/material'
import './NumberRangeFilter.scss'
import { useState } from 'react'

interface INumberRangeFilterProps {
    label: string,
    value: string,
    valueChanged: (newValue: string) => void,
    min_value?: number,
    max_value?: number
}

const NumberRangeFilter = (props: INumberRangeFilterProps) => {

    const [inputValue, setInputValue] = useState<Array<number>>([props.min_value || 0, props.max_value || 500])

    const handleChange = (event: Event, newValue: number[]) => {
        // if new value is the min/max, the filter gets ignored
        let newValueString = ""
        if (props.min_value === undefined || newValue[0] !== props.min_value)
            newValueString = `${newValue[0]}|`  

        if(!props.max_value === undefined || newValue[1] !== props.max_value){
            if (!newValueString.startsWith("|"))
                newValueString += "|"

            newValueString += `${newValue[1]}|`
        }
        setInputValue(newValue);
        props.valueChanged(newValueString)
    };

    return (
        <div className='number-range-filter-wrapper'>
            <span>{props.label}</span>
            <div className='number-range-slider-wrapper'>
                <div style={{width: "40px"}}>{inputValue[0]}</div>
                <Slider
                    value={inputValue}
                    onChange={handleChange}
                    min={props.min_value}
                    max={props.max_value}
                    step={100}
                    sx={{width: 150}}
                />
                <div style={{width: "40px"}}>{inputValue[1]}</div>
            </div>
        </div>
    )
}

export default NumberRangeFilter